var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiagramCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 30C6.9 30 6 30.9 6 32V38C6 40.2 7.8 42 10 42H16C17.1 42 18 41.1 18 40C18 38.9 17.1 38 16 38H12C10.9 38 10 37.1 10 36V32C10 30.9 9.1 30 8 30ZM10 12C10 10.9 10.9 10 12 10H16C17.1 10 18 9.1 18 8C18 6.9 17.1 6 16 6H10C7.8 6 6 7.8 6 10V16C6 17.1 6.9 18 8 18C9.1 18 10 17.1 10 16V12ZM38 6H32C30.9 6 30 6.9 30 8C30 9.1 30.9 10 32 10H36C37.1 10 38 10.9 38 12V16C38 17.1 38.9 18 40 18C41.1 18 42 17.1 42 16V10C42 7.8 40.2 6 38 6ZM38 36C38 37.1 37.1 38 36 38H32C30.9 38 30 38.9 30 40C30 41.1 30.9 42 32 42H38C40.2 42 42 40.2 42 38V32C42 30.9 41.1 30 40 30C38.9 30 38 30.9 38 32V36ZM24 18C20.68 18 18 20.68 18 24C18 27.32 20.68 30 24 30C27.32 30 30 27.32 30 24C30 20.68 27.32 18 24 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramCenter);
export default __webpack_public_path__ + "static/media/diagram_center.848f091cfc50c50df7bba63920562d28.svg";
export { ForwardRef as ReactComponent };